// SGI Faculty Appraisal — Part I (A) / Part I (B) field definitions (shared by form + print report)

export const PROFILE_FIELDS = [
  { key: 'name', label: 'Name of Faculty' },
  { key: 'institute', label: 'Name of Institute' },
  { key: 'designation', label: 'Designation' },
  { key: 'department', label: 'Department' },
  { key: 'email', label: 'Email', type: 'email' },
  { key: 'contact_no', label: 'Contact No.' },
  { key: 'address', label: 'Address' },
  { key: 'date_of_birth', label: 'Date of Birth', type: 'date' },
  { key: 'doj_institution', label: 'Date of Appointment in Institution', type: 'date' },
  { key: 'doj_present_post', label: 'Date of Appointment to Present Post', type: 'date' },
];

export const COURSE_COLS = [
  { key: 'duration_semester', label: 'Duration of Semester' },
  { key: 'course', label: 'Course / Subject Taught' },
  { key: 'sem_branch', label: 'Semester / Branch' },
  { key: 'total_classes', label: 'Total Classes as per Time Table' },
  { key: 'actual_classes', label: 'Actual Classes Conducted' },
  { key: 'curriculum_pct', label: '% Curriculum Covered' },
  { key: 'result_pct', label: 'Subject Result in %' },
];

export const BOOK_COLS = [
  { key: 'title', label: 'Title of a Book' },
  { key: 'book_type', label: 'Reference / Text Book' },
  { key: 'authors', label: 'Author/s' },
  { key: 'publisher', label: 'Publisher' },
  { key: 'year', label: 'Year of Publication' },
  { key: 'chapters', label: 'Contributed Chapter/s' },
  { key: 'isbn', label: 'ISBN / ISSN No.' },
];

export const PAPER_COLS = [
  { key: 'title', label: 'Title of a Research Paper' },
  { key: 'authors', label: 'Author/s' },
  { key: 'journal', label: 'Name of a Journal' },
  { key: 'date', label: 'Date of Publication' },
  { key: 'isbn', label: 'ISBN / ISSN No.' },
];

export const FEEDBACK_COLS = [
  { key: 'course', label: 'Name of Theory Course Taught' },
  { key: 'sem_branch', label: 'Sem / Branch' },
  { key: 'feedback_index', label: 'Feedback Index' },
];

export const GUARDIAN_FIELDS = [
  { key: 'students_allocated', label: 'No. of Students Allocated' },
  { key: 'meetings_conducted', label: 'No. of Meetings Conducted with Students' },
  { key: 'all_clear', label: 'No. of Students Clearing All Subjects' },
  { key: 'atkt', label: 'No. of ATKT Students' },
  { key: 'att_80_plus', label: 'Students with Attendance > 80%' },
  { key: 'att_60_80', label: 'Students with Attendance 60 to 80%' },
  { key: 'att_40_60', label: 'Students with Attendance 40 to 60%' },
  { key: 'att_30_40', label: 'Students with Attendance 30 to 40%' },
];

// Long-form narrative blocks, in the exact order of the printed form
export const TEXT_BLOCKS = [
  { key: 'academic_qualification', label: 'Academic Qualification', hint: 'Mention if any additional qualification is acquired during the year under review' },
  { key: 'shortfall_reasons', label: 'Reasons for Shortfall, if any, in Conduct & Result of Theory / Lab Courses' },
  { key: 'learning_material', label: 'Contribution to Subject Learning Material Development' },
  { key: 'lab_development', label: 'Contribution to the Laboratory Development' },
  { key: 'portfolios_dept', label: 'Additional Portfolios Handled — a. Department Level' },
  { key: 'portfolios_institute', label: 'Additional Portfolios Handled — b. Institute Level' },
  { key: 'cocurricular', label: 'Contribution in Co-curricular / Extracurricular / Extension Activities' },
  { key: 'participation_seminars', label: 'Participation in Seminars / Workshops / STTP / Orientations / FDP', hint: 'Attach certificates for the courses attended' },
  { key: 'organization_seminars', label: 'Organization of Seminar / Workshops / Webinars / FDP' },
  { key: 'innovation', label: 'Innovation of Any Type Introduced in Institute' },
  { key: 'research_guidance', label: 'Research Project Guidance', hint: 'Title of project, name of students, co-supervisor if any' },
  { key: 'consultancy', label: 'Contribution to Industrial Development (Consultancy / Sponsored R&D etc.)' },
  { key: 'examination_duties', label: 'Contribution to the Examination Duties', hint: 'Assessment and other activities of theory & practical examination other than supervision' },
  { key: 'higher_education', label: 'Higher Education', hint: 'Pursual of Ph.D / any other higher education and current status' },
  { key: 'awards', label: 'Individual Awards or Recognition', hint: 'District / State / National level' },
  { key: 'student_competitions', label: 'Student Guidance for Various Competitions', hint: 'State / National level competition, organizers, names of students and result' },
  { key: 'revenue_steps', label: 'Any Step for the Revenue Generation', hint: 'Other than industrial consultancies' },
  { key: 'memberships', label: 'Membership of Professional Societies' },
  { key: 'other_contribution', label: 'Any Other Relevant Contribution Not Covered Above' },
  { key: 'next_period_plan', label: 'Planning of Any Activity for Next Evaluation Period' },
];

export const ADMISSION_ROWS = [
  'Engineering F. Y.',
  'Polytechnic F.Y.',
  'Polytechnic D. Y.',
  'Polytechnic DSY',
  'S.G.I.T.I',
];

export const STATUS_META = {
  pending: { label: 'Pending with Staff', cls: 'bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300' },
  returned: { label: 'Returned for Correction', cls: 'bg-orange-100 text-orange-800 dark:bg-orange-900/30 dark:text-orange-300' },
  submitted: { label: 'Awaiting Evaluation', cls: 'bg-blue-100 text-blue-800 dark:bg-blue-900/30 dark:text-blue-300' },
  hod_evaluated: { label: 'Awaiting Director Approval', cls: 'bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-300' },
  approved: { label: 'Approved', cls: 'bg-emerald-100 text-emerald-800 dark:bg-emerald-900/30 dark:text-emerald-300' },
};

export const emptyRow = (cols) => cols.reduce((a, c) => ({ ...a, [c.key]: '' }), {});
